export default "A floorplan creator applet I've created.\n[floorplan.pro](https://floorplan.pro/)"